import {
  Column,
  CreateDateColumn,
  Entity,
  PrimaryGeneratedColumn,
  UpdateDateColumn,
  VersionColumn,
} from 'typeorm';

@Entity('sku_price_logs')
export class SkuPriceLogs {
  @PrimaryGeneratedColumn('increment', { name: 'sku_price_log_id' })
  skuPriceLogId: number;

  @Column('int', {
    name: 'sku_id',
    nullable: false,
  })
  skuId: number;

  @Column({
    name: 'effective_from_date',
    type: 'datetime',
    nullable: false,
  })
  effectiveFromDate: Date;

  @Column('decimal', {
    name: 'price',
    precision: 10,
    scale: 2,
    nullable: false,
  })
  price: number;

  @Column('varchar', {
    name: 'created_user',
    length: 50,
    nullable: false,
  })
  createdUser: string;

  @CreateDateColumn({
    name: 'created_at',
    type: 'datetime',
  })
  createdAt: Date;

  @UpdateDateColumn({
    name: 'updated_at',
    type: 'datetime',
  })
  updatedAt: Date;

  @Column('varchar', {
    name: 'updated_user',
    length: 50,
    nullable: true,
  })
  updatedUser: string;

  @VersionColumn({
    name: 'version_flag',
    default: 1,
  })
  versionFlag: number;
}